module.exports = __webpack_public_path__ + "img/image.f37306f3.png";